'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable multiline-ternary */
/* eslint-disable no-prototype-builtins */
/* eslint-disable spaced-comment */
/* eslint-disable @typescript-eslint/block-spacing */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/promise-function-async */
/* eslint-disable react/no-unstable-nested-components */

import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import { getHealthDetailsCompDynamically } from '@components/utils/health-input-detail-dynamic-import'
import Shimmer from '@components/Shimmer/Shimmer'
import styles from './healthWidget.module.scss'

interface PropTypes {
  onHide?: any
  segmentEventCommonProperties?: any
  isBottomFloater?: boolean
  isMobileDevice?: boolean
  addScroll?: boolean
}

const HealthInputDetailsWidget = ({
  onHide,
  isBottomFloater,
  segmentEventCommonProperties,
  isMobileDevice = false,
  addScroll,
}: PropTypes) => {
  const [healthInputOpen, setHealthInputOpen] = useState(false)
  const [HealthDynamicWidget, setHealthDynamicWidget] = useState<any>({})

  const formTitle = 'Get your family the ACKO Health cover'

  useEffect(() => {
    getHealthDetailsCompDynamically(healthInputOpen, setHealthDynamicWidget, isBottomFloater)
  }, [healthInputOpen, isBottomFloater])

  const HealthSeoWidgetDesktopForm: any = React.useMemo(() =>
    dynamic(
      () =>
        import('@acko-tech/health-retail-components.health-retail-components.sem-input-details').then(
          mod => mod.DesktopForm
        ),
      {
        ssr: false,
        loading: () => <Shimmer />
      }
    ),
    []
  )

  const segmentEvent = async segmentParams => {
    const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
    await trackEvent('tap_btn_CTA_widget', {
      ...properties,
      funnel: 'entry',
      phone: segmentParams?.phoneNumber,
    })
  }

  return (
    <div className={`${styles.WidgetContainer} ${addScroll ? styles.addScroll : ''}`}>
      {healthInputOpen ? (
        HealthDynamicWidget.hasOwnProperty('Overlay') && (
          <HealthDynamicWidget.Overlay open setOpen={setHealthInputOpen} handleTrack={segmentEvent} title={formTitle} />
        )
      ) : (
        <div className={styles.ButtonContainer}>
          <button type="button" className={styles.renderWidgetButton} onClick={() => setHealthInputOpen(true)}>
            <span>Check prices</span>
          </button>
        </div>
      )}

      {isBottomFloater && HealthDynamicWidget.hasOwnProperty('Overlay') && (
        <div className={styles.healthWidgetVisibleMobile}>
          <HealthDynamicWidget.Overlay open setOpen={onHide} handleTrack={segmentEvent} title={formTitle} />
        </div>
      )}

      {/* {!isMobile && ( */}

      <div className={styles.healthWidgetVisibleDesktop}>
          {HealthSeoWidgetDesktopForm && <HealthSeoWidgetDesktopForm handleTrack={segmentEvent} title={formTitle} />}
      </div>
    </div>
  )
}

export default HealthInputDetailsWidget
